import { IFeature } from "../../common/models/feature.model";
import { createDefaultLoadable, ILoadableArray, ILoadableWrapper } from "../../common/models/loadable";

export interface IFeatureState {
    features: ILoadableArray<ILoadableWrapper<IFeature>>
}

export const initalFeatureState: IFeatureState = {
    features: {
        ...createDefaultLoadable(),
        items: []
    }
}